import { Link } from 'react-router';
import { MapPin } from 'lucide-react';
import { useBookingLocation } from '@/hooks/useBookingLocation';
import { formatLocationName } from '@/lib/bookingDestination';

export function BookingDestination() {
    const { location, isValid, isMixed } = useBookingLocation();
    if (!isValid || !location) {
        return (
            <div role="alert" className="rounded-lg border border-warning-border bg-warning-subtle p-4 text-sm text-foreground">
                <p className="font-semibold">{isMixed ? 'Your cart contains different pickup destinations' : 'Check your pickup destination'}</p>
                <p className="mt-1">Each booking must have one pickup and return destination. Remove items for other locations or start a new booking.</p>
                <Link to="/cart" className="mt-2 inline-flex min-h-11 items-center font-semibold text-primary underline">Review cart</Link>
            </div>
        );
    }
    return (
        <div className="flex min-w-0 items-start gap-3 rounded-lg border border-primary/25 bg-primary/5 p-4">
            <MapPin className="mt-1 h-5 w-5 shrink-0 text-primary" aria-hidden="true" />
            <div className="min-w-0">
                <p className="text-sm text-foreground">Collect &amp; return</p>
                <p className="break-words text-base font-bold text-foreground">{formatLocationName(location)}</p>
                {location.address && <p className="mt-1 text-sm text-muted-foreground">{location.address}</p>}
            </div>
        </div>
    );
}
